/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './flacc-score.reducer';

export const FlaccScoreDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const flaccScoreEntity = useAppSelector(state => state.flaccScore.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="flaccScoreDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.flaccScore.detail.title">FlaccScore</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.flaccScore.id">Id</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.id}</dd>
          <dt>
            <span id="face">
              <Translate contentKey="tinyMedicRestApp.flaccScore.face">Face</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.face}</dd>
          <dt>
            <span id="cry">
              <Translate contentKey="tinyMedicRestApp.flaccScore.cry">Cry</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.cry}</dd>
          <dt>
            <span id="acctivity">
              <Translate contentKey="tinyMedicRestApp.flaccScore.acctivity">Acctivity</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.acctivity}</dd>
          <dt>
            <span id="consolability">
              <Translate contentKey="tinyMedicRestApp.flaccScore.consolability">Consolability</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.consolability}</dd>
          <dt>
            <span id="legs">
              <Translate contentKey="tinyMedicRestApp.flaccScore.legs">Legs</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.legs}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.flaccScore.active">Active</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.flaccScore.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.flaccScore.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.flaccScore.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.flaccScore.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{flaccScoreEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.flaccScore.patient">Patient</Translate>
          </dt>
          <dd>{flaccScoreEntity.patient ? flaccScoreEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/flacc-score" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/flacc-score/${flaccScoreEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FlaccScoreDetail;
